/**
 * oc-tag — 정보공유방 태그를 «어디서» 내는가(순수).
 * 콘텐츠 면(현장 상세·블로그·게시판·지역/캘린더/허브)에만. 입력·결제·계정 화면에는 내지 않는다.
 */
const HIDE_PREFIX = ['/login', '/signup', '/auth', '/write', '/payment', '/profile', '/settings', '/admin', '/ads', '/notifications', '/onboarding'];

export function openchatTagAllowed(pathname: string | null | undefined): boolean {
  const p = String(pathname ?? '');
  if (!p) return false;
  return !HIDE_PREFIX.some((h) => p === h || p.startsWith(`${h}/`));
}

/** /apt/{slug} 상세면 slug(계측용) — 허브(/apt/region 등)는 null. */
export function siteSlugOf(pathname: string | null | undefined): string | null {
  const m = /^\/apt\/([^/]+)$/.exec(String(pathname ?? ''));
  if (!m) return null;
  const s = m[1];
  if (['region', 'area', 'redev', 'unsold', 'calendar', 'map', 'search', 'ranking', 'list', 'popular', 'compare', 'sites', 'stage', 'theme', 'builder', 'data', 'feed', 'gallery', 'archive', 'big-events', 'complex', 'landmark', 'pipeline', 'unsold-deals', 'diagnose'].includes(s)) return null;
  try { return decodeURIComponent(s); } catch { return s; }
}

/** 종전 «누르면 30일 숨김» 저장 키 — oc-always(2026-11-02)부터 읽지 않고 지우기만 한다. */
export const OC_HIDE_KEY = 'kd_oc_hide_until';
